/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsSacFinderViewProps } from './../../../modules/hosports-sac-finder/./hosports-sac-finder';
//@ts-ignore
import {ModelYear,GeneralAssetUrl} from './../utilities/constants';
//@ts-ignore
import Parse from 'parse';
// @ts-ignore
import ProductTile from './../../../baseComponents/product-tile/./product-tile';
/**
 *
 * HosportsSacFinder component
 * @extends {React.PureComponentReact.Component<IHosportsSacFinderViewProps>}
 */
 interface IState {
   questionOne?:any;
   questionTwo?:any;
   leftMargin?:any;
   packageName?:any;
   packageProducts?:any;
   footPrint?:any;
   HosportsButtonRowtionary?:any;
   productDictionary?:any;
 }

class HosportsSacFinder extends React.Component<IHosportsSacFinderViewProps> {

  public state: IState;

  constructor (props: IHosportsSacFinderViewProps) {
      super(props);
      this.state = {};
  }
  public componentDidMount = async() =>{

    let {config} = this.props;
    let year = config.year ? config.year : ModelYear;
    let searchQuery:any = Parse.Object.extend('Products'+year);
    let query:any = new Parse.Query(searchQuery);
    query.equalTo("category","lDtB8joWup");
    query.ascending("order");
    query.limit(500);
    let results: any = await query.find()
    let productDictionary:any = {}
    results.map((data:any, index:any)=>{
      productDictionary[data.attributes.slug]=data;
      if(index == results.length -1){
        console.log(productDictionary)
        this.setState({
          productDictionary:productDictionary
        })
      }
    })
  }
  public answerQuestionOne = (value:any) =>{
    this.setState({
      questionOne:value,
      leftMargin:'-100%'
    })
  }
  public answerQuestionTwo = (value:any) =>{
    this.setState({
      questionTwo:value,
      leftMargin:'-200%'
    }, () => {
      this.endQuiz();
    });
  }

  public endQuiz = () =>{
    packages.map((value:any,index:any) =>{
      if(value.answers[0] == this.state.questionOne && value.answers[1] == this.state.questionTwo){
        let packageProducts:any = [];
        value.products.map((data:any, index:any)=>{
          if(this.state.productDictionary){
            let product:any = this.state.productDictionary[data];
            packageProducts.push(product)
            if(index == value.products.length -1){
              this.setState({
                packageName:value.name,
                footPrint:value.image,
                packageProducts:packageProducts
              })
            }
          }
        })
  		}
    })
  }
  public render(): JSX.Element {
    const { config } = this.props;
    let background1Image = config.question1Background ? config.question1Background.src : undefined;
    let background2Image = config.question2Background ? config.question2Background.src : undefined;
    return (
      <div className="quiz-container white-background" style={{marginTop:100}}>
      <div className="quiz-scroll-container" style={{marginLeft:this.state.leftMargin}}>
        <div className="quiz-frame full-width">
          <div className="row full-width">
            <div className="small-12 medium-6 small-padding">
              <div className="row full-width small-centered-text">
                <div style={{margin:'auto', marginTop:'40px'}}>
                  <h3>{'What type of boat do you have?'}</h3>
                  <div className="tiny-padding">
                    <div className="button black-background centered-text" style={{color:"#fff",width:"50%", cursor:'pointer'}} onClick={()=>this.answerQuestionOne('V-Drive')}>{'V-Drive'}</div>
                  </div>
                  <div className="tiny-padding">
                    <div className="button black-background centered-text" style={{color:"#fff",width:"50%", cursor:'pointer'}} onClick={()=>this.answerQuestionOne('Direct Drive')}>{'Direct Drive'}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="small-12 medium-6">
              {background1Image && <img className="full-width" src={background1Image} />}
            </div>
          </div>
        </div>
        <div className="quiz-frame full-width">
          <div className="row full-width">
            <div className="small-12 medium-6 small-padding">
              <div className="row full-width" style={{alignItems:'center', justifyContent:'center'}}>
                <div style={{margin:'auto', marginTop:'40px'}}>
                  <h3>{'How big of a wake do you want?'}</h3>
                  <div className="tiny-padding">
                  <div className="button black-background centered-text" style={{color:"#fff",width:"50%", cursor:'pointer'}} onClick={()=>this.answerQuestionTwo('Beginner')}>{'Beginner'}</div>
                  </div>
                  <div className="tiny-padding">
                    <div className="button black-background centered-text" style={{color:"#fff",width:"50%", cursor:'pointer'}} onClick={()=>this.answerQuestionTwo('Intermediate')}>{'Intermediate'}</div>
                  </div>
                  <div className="tiny-padding">
                    <div className="button black-background centered-text" style={{color:"#fff",width:"50%", cursor:'pointer'}} onClick={()=>this.answerQuestionTwo('Advanced/Pro')}>{'Advanced/Pro'}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="small-12 medium-6">
              {background2Image && <img className="full-width" src={background2Image} />}
            </div>
          </div>
        </div>
        <div className="quiz-frame quiz-results full-width">
          <div className="row full-width">
            <div className="small-12 medium-6 small-padding small-centered-text">
              <h2 className="full-width">{this.state.packageName}</h2>
              <div className="row">
                <div className="centered-text" style={{margin:'auto'}}>
                  <img className="footprint full-width" src={GeneralAssetUrl+this.state.footPrint} />
                </div>
              </div>
            </div>
            <div className="small-12 medium-6 small-padding">
              <div style={{textAlign:'right'}}>
                <a href={'/sacFinder'} className="button background-background" style={{color:'#fff'}}>{'Start Over'}</a>
              </div>
              <div className="row sac-results">
                {this.state.packageProducts &&
                  <div className={"row full-width"}>
                    {this.state.packageProducts.map((data:any,index:any) => {
                      return(
                        <div className={"small-12 medium-6"}>
                          <ProductTile
                            product={data} />
                        </div>
                      )})}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
}

export default HosportsSacFinder;

const packages = [
	{
		'name':'V-Drive Slammed',
		'answers':["V-Drive","Advanced/Pro"],
		'products':["ballast-jumbo-surf","ballast-jumbo-surf","ballast-open-bow","ballast-supa-tsunami-pump","ballast-supa-tsunami-pump"],
		'configuration':["w_706","w_709","w_719"],
		'footprint':"v-drive-footprint",
    'image':'finder-v-drive-slammed.jpg'
	},
	{
		'name':'V-Drive Enhanced',
		'answers':["V-Drive","Intermediate"],
		'products':["ballast-fat-sac","ballast-fat-sac","ballast-open-bow","ballast-supa-tsunami-pump"],
		'configuration':["w_706","w_707","w_709"],
		'footprint':"v-drive-footprint",
    'image':'finder-v-drive-enhanced.jpg'
	},
  {
		'name':'V-Drive Beginner',
		'answers':["V-Drive","Beginner"],
		'products':["ballast-v-drive","ballast-open-bow","ballast-supa-tsunami-pump"],
		'configuration':["w_701","w_706","w_709"],
		'footprint':"v-drive-footprint",
    'image':'finder-v-drive-enhanced.jpg'
	},
	{
		'name':'Direct Drive Slammed',
		'answers':["Direct Drive","Advanced/Pro"],
    'products':["ballast-jumbo-surf","ballast-jumbo-surf","ballast-open-bow","ballast-supa-tsunami-pump","ballast-supa-tsunami-pump"],
    'configuration':["w_706","w_709","w_719"],
		'footprint':"direct-drive-footprint",
    'image':'finder-direct-drive-slammed.jpg'
	},
	{
		'name':'Direct Drive Enhanced',
		'answers':["Direct Drive","Intermediate"],
    'products':["ballast-fat-sac","ballast-fat-sac","ballast-open-bow","ballast-supa-tsunami-pump"],
		'configuration':["w_706","w_707","w_709"],
		'footprint':"direct-drive-footprint",
    'image':'finder-direct-drive-slammed.jpg'
	},
  {
		'name':'Direct Drive Beginner',
		'answers':["Direct Drive","Beginner"],
		'products':["ballast-v-drive","ballast-open-bow","ballast-supa-tsunami-pump"],
		'configuration':["w_701","w_706","w_709"],
		'footprint':"direct-drive-footprint",
    'image':'finder-direct-drive-slammed.jpg'
	}
];
